export default __webpack_public_path__ + "static/media/open.6b5b829c.svg";